<template>
    <div class="d-flex flex-column gap-4">
        <IncludedOrderStatesBox :order-states="statistics.order_states" />

        <div class="d-md-flex flex-row justify-content-center">
            <div class="w-xl-25 w-md-50 w-100">
                <apexchart type="donut"
                           height="280"
                           :options="chartOptions"
                           :series="chartSeries"
                />
            </div>
        </div>

        <div class="gap-4 d-flex flex-row flex-wrap w-100">
            <div v-for="channelStatistics in statistics.data"
                 :key="channelStatistics.integration.code"
                 class="flex-grow-1 d-flex flex-column gap-2 rounded px-8 px-lg-12 pb-lg-12 py-8 card card-body"
            >
                <div class="d-flex flex-row gap-2 align-items-center text-3xl m-2" style="opacity: 0.7;">
                    <div>
                        <i :class="[channelStatistics.integration.icon]" style="font-size:inherit; color:inherit;"/>
                    </div>
                    <div class="font-weight-bold">
                        {{ channelStatistics.integration.name }}
                    </div>
                </div>
                <ChannelStatsRow :channel-statistics="channelStatistics"/>
                <div class="flex-grow-1 d-flex flex-column flex-md-row gap-2 gap-lg-8 rounded p-8"
                     :style="`background-color: ${tinycolor(channelStatistics.integration.color).desaturate(50).brighten(20)};`"
                >
                    <div>
                        <div class="font-weight-bold text-lg mb-1">{{ __('general.stores') }}:</div>
                        <div class="d-flex flex-column gap-1">
                            <Store v-for="storeUuid in channelStatistics.store_uuids"
                                   :key="storeUuid"
                                   :store="stores[storeUuid]"
                                   no-image
                            />
                        </div>
                    </div>
                    <div>
                        <div class="font-weight-bold text-lg mb-1">{{ __('orders.popular_articles') }}:</div>
                        <div>
                            <div v-for="(orders, identifier) in channelStatistics.identifiers">
                                {{ orders }} x {{ identifier }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OrderStatisticsLayout from "@layouts/Statistics/OrderStatisticsLayout.vue";
import ChannelStatsRow from "@components/Stats/Components/ChannelStatsRow.vue";
import Store from "@components/Store/Store.vue";
import tinycolor from "tinycolor2";
import IncludedOrderStatesBox from "@components/Stats/IncludedOrderStatesBox.vue";

export default {
    layout: OrderStatisticsLayout,

    components: {
        IncludedOrderStatesBox,
        Store,
        ChannelStatsRow,
    },

    props: {
        stores: Object,
        statistics: {
            types: [Object, Array]
        },
    },

    data() {
        return {
            chartOptions: {
                chart: {
                    width: '100%',
                },
                plotOptions: {
                    pie: {
                        expandOnClick: false,
                        dataLabels: {
                            offset: 0,
                            minAngleToShowLabel: 10,
                        },
                        donut: {
                            size: '50%',
                            labels: {
                                show: true,
                                total: {
                                    show: true,
                                    showAlways: true,
                                    label: __('general.total'),
                                    fontSize: '1.4em',
                                    fontWeight: 600,
                                }
                            }
                        }
                    },
                },
                stroke: {
                    width: 0,
                },
                legend: {
                    horizontalAlign: 'center',
                    formatter: function (seriesName, opts) {
                        let fulfilled = opts.w.globals.series[opts.seriesIndex];
                        return `<b>${seriesName}</b><br>${__('orders.orders')}: ${fulfilled || 0}`;
                    }
                },
                colors: this.statistics.data.map(channelStatistics => channelStatistics.integration.color),
                labels: this.statistics.data.map(channelStatistics => channelStatistics.integration.name),
            },
        }
    },

    methods: {
        tinycolor,
        barWidth(ordersInChannel) {
            let width = 0;

            if (this.totalOrders > 0) {
                width = ordersInChannel * 100 / this.totalOrders;
            }

            return `width: ${width}%;`;
        },
    },

    computed: {
        chartSeries() {
            return this.statistics.data.map(channelStatistics => channelStatistics.orders_fulfilled)
        },

        totalOrders() {
            return this.statistics.data.reduce((prev, current) => prev + current.orders_fulfilled, 0)
        },
    }
}
</script>
